import React, { useCallback, useState } from "react"

import { toggleModal } from "components/Stacker/actions/ModalActions"
import { selectQuickViewProduct } from "components/Stacker/actions/ProductDetailActions"
import {
  setProductItemLoaded,
  showProductInfoPanel,
} from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import SlickArrow from "components/Stacker/components/SlickArrow/SlickArrow"
import SwatchSetMultiple from "components/Stacker/components/Common/SwatchSetMultiple/SwatchSetMultiple"
import ModalConfig from "components/Stacker/config/ModalConfig"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import queryString from "query-string"

import { useLocation } from "react-router"
import { useNavigate } from "react-router-dom"
import SelectButton from "../../Common/SelectButton/SelectButton"
import "../../ProductList/ProductItem/ProductItem.scss"
import "./BraceletProductItem.scss"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

const isProductInQuery = (location, product) => {
  const queryObj = queryString.parse(location.search, { decode: true })
  let queryProducts = []
  if (queryObj.products) {
    queryProducts = Array.isArray(queryObj.products)
      ? queryObj.products.map((product) => product.replace(/-/, " "))
      : [queryObj.products.replace(/-/, " ")]
  }

  var productInQuery = queryProducts.includes(product.baseProduct)
  var variantInQuery = product.variants.find((v) => {
    return queryProducts.includes(v.code) == true
  })
  return productInQuery || variantInQuery != null
}

function ProductItem({
  product,
  selected,
  selectedIndex,
  selectedIndices,
  showSwatches = false,
  src,
  style,
  maxItems,
}) {
  const { LL } = useI18nContext()
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  // Force selected state based on querystring
  selected = isProductInQuery(location, product)

  const onProductClick = useCallback(
    (code) => {
      const queryObj = queryString.parse(location.search, { decode: true })
      const addedStack = Array.isArray(queryObj.products)
        ? queryObj.products
        : [queryObj.products]

      const isRemove = addedStack.includes(code)
      if (addedStack.length === maxItems && !isRemove) {
        dispatch(toggleModal(ModalConfig.MODAL_STACKER_AMOUNT, true))
        return
      }

      const productIdStack = !addedStack.includes(code)
        ? [...addedStack, code]
        : [
            ...addedStack.filter((item) => {
              return item !== code
            }),
          ]

      const queryParamsString = queryString.stringify(
        { ...queryObj, products: productIdStack },
        { encode: true }
      )
      //dispatch(push(`${location.pathname}?${queryParamsString}`));
      navigate(`${location.pathname}?${queryParamsString}`)
    },
    [dispatch, navigate, location.pathname, location.search, maxItems]
  )

  const onImageLoaded = useCallback(() => {
    if (!isImageLoaded) {
      dispatch(setProductItemLoaded())
    }
    setIsImageLoaded(true)
  }, [dispatch, isImageLoaded])

  const onQuickViewClick = useCallback(
    (e) => {
      const { pid, url } = e.currentTarget.dataset
      dispatch(selectQuickViewProduct(pid, url))
      dispatch(toggleModal(ModalConfig.MODAL_QUICK_VIEW, true))
    },
    [dispatch]
  )

  const buttonClass = classNames("btn", "product_stacker-btn", { selected })
  let swatchSettings = {}
  if (selectedIndices.length) {
    // console.group();
    // console.log(selectedIndices, selectedIndex);
    // console.groupEnd();
  }

  if (showSwatches) {
    const swatchAmt = isMobile() ? 5 : 7
    swatchSettings = {
      dots: false,
      infinite: true,
      accessibility: true,
      centerPadding: "-1px",
      centerMode: true,
      slidesToShow:
        product.variants.length < swatchAmt
          ? product.variants.length
          : swatchAmt,
      slidesToScroll: 1,
      speed: 500,
      nextArrow: <SlickArrow iconName="icon-arrow-right" />,
      prevArrow: <SlickArrow iconName="icon-arrow-left" />,
    }
  }

  const stackerClasses = classNames("product_stacker product_list-item", {
    selected,
  })
  const selectedVariant = product.variants[selectedIndex]

  return (
    <div className={stackerClasses} style={style}>
      <div key={product.code} className={buttonClass}>
        <button
          className="product_list-item-border"
          onClick={() => onProductClick(selectedVariant.code)}
        />
        {/* //TODO: was d-inline before needing to hide for portable */}
        <button
          className="btn btn-text btn-text-quickview"
          data-pid={product.baseProduct}
          data-url={product.url}
          onClick={onQuickViewClick}
          style={{ display: "none" }}
        >
          {LL.bracelets.quickView()}
        </button>
        <img
          alt={product.baseProduct}
          src={src}
          width="100%"
          onLoad={onImageLoaded}
        />
        <div className="product_list-name">
          <p className="minion-font px-2">{selectedVariant.rawTitle}</p>
        </div>
      </div>
      {showSwatches && product.variants.length > 1 && (
        <SwatchSetMultiple
          baseProductCode={product.baseProduct}
          defaultSelectedIndex={selectedIndex}
          isSelected={selected}
          isSlider
          productVariants={product.variants}
          selectedVariantIndices={selectedIndices}
          swatchSettings={swatchSettings}
        />
      )}

      {selected && (
        <React.Fragment>
          <SelectButton
            className="product_stacker-button_selected"
            selected={selected}
          />
        </React.Fragment>
      )}
    </div>
  )
}

export default ProductItem

ProductItem.propTypes = {
  maxItems: PropTypes.number.isRequired,
  product: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectedIndices: PropTypes.array.isRequired,
  showSwatches: PropTypes.bool,
  src: PropTypes.string.isRequired,
  style: PropTypes.object,
}
